import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import NewFormField from '../../common/layout/form/NewFormField';
import FormDropDown from '../../common/layout/form/FormDropDown';
import FormDatePicker from '../../common/layout/form/FormDatePicker';
import FileInput from '../../common/layout/form/FileInput';
import ClientsDropDown from '../../orders/components/forms/newOrder/ClientsDropDown';
import { margin } from '../../clients/styles/panelForm.styles';
import ActivityIndicator from '../../common/layout/ActivityIndicator';
import { useCancelForm } from '../../clients/hooks/useCancelForm';
import ErrorMessage from '../../common/layout/form/ErrorMessage';
import FormDropDownReception from '../../common/layout/form/FormDropDownReception';
import NewFormBtns from '../../common/layout/form/NewFormBtns';
import { useCompanyData } from '../../orders/hooks/useCompanyData';
import { DocumentTypeEnum } from '../models/DocumentTypeEnums';
import FormDropDownInternalStore from '../../common/layout/form/FormDropDownInternalStore';
import { getInternalStoreItems } from '../../../connectors/store/connectors';
import { useStoreDocsAddFile } from '../hooks/useStoreDocsAddFile';

// The date was required by the native date input (HTML required attribute); the date picker needs explicit validation
const storeDocsAddSchema = yup.object().shape({
    documentDate: yup.string().required(),
});

const StoreDocsAddForm = () => {
    const { t } = useTranslation("admin");
    const {
        arrangementFileHandler,
        handleSubmit,
        isLoading
    } = useStoreDocsAddFile();

    const [documentType, setDocumentType] = useState<any>({ key: -1 });
    const [company, setCompany] = useState<any>({ key: "" });
    const [department, setDepartment] = useState<any>({ key: -1 });
    const [reception, setReception] = useState<any>();
    const [internalStore, setInternalStore] = useState<any>();
    const [internalStoreOptions, setInternalStoreOptions] = useState<any[]>([]);

    const {
        departments,
        receptionPlaces,
    } = useCompanyData(company, department, reception);

    const cancel = useCancelForm();

    if (company.data && company.data.multiDepartment === false) {
        if (departments[0] && (department.key === 0 || department.key !== departments[0]['key'])) {
            setDepartment(departments[0]);
        }
    }

    useEffect(() => {
        (async () => {
            const res = await getInternalStoreItems();
            const options = res.data.data.map((option: any) => {
                // let msg = !option.isActive ? '(Nieaktywny)' : ''
                return {
                    key: option.storeId,
                    text: `${option.name}`,
                    // orderTypeId: option.orderTypeId,
                    // disabled: !option.isActive
                };
            });

            setInternalStoreOptions(options);
        })();
    }, []);

    return (
        <Formik
            onSubmit={handleSubmit}
            initialValues={{}}
            validationSchema={storeDocsAddSchema}
            validateOnChange={false}
            validateOnBlur={false}
        >
            {({ handleSubmit, setFieldValue }) => (
                <Form translate="yes" onSubmit={handleSubmit}>
                    <FormDropDown
                        headerText={t("nav.panelDocumentType") as string}
                        name="documentType"
                        options={[
                            { key: DocumentTypeEnum.CONTRACT, text: t("nav.docTypeContract") },
                            { key: DocumentTypeEnum.ACCEPTANCE_REPORT, text: t("nav.docTypeAcceptanceReport") },
                            { key: DocumentTypeEnum.HANDOVER_PROTOCOL, text: t("nav.docTypeHandoverProtocol") },
                            { key: DocumentTypeEnum.EXTERNAL_RECEPTION, text: t("nav.docTypeExternalReception") },
                            { key: DocumentTypeEnum.DESTRUCTION_PROTOCOL, text: t("nav.docTypeDestructionProtocol") },
                            { key: DocumentTypeEnum.INVENTORY, text: t("nav.docTypeInventory") },
                            { key: DocumentTypeEnum.MM_MINUS, text: t("nav.docTypeMMminus") },
                            { key: DocumentTypeEnum.MM_PLUS, text: t("nav.docTypeMMplus") },
                        ]}
                        onChange={(value: any) => setDocumentType({ key: value.key })}
                    />

                    <NewFormField name="description" label={t("nav.documentNumber") as string} />

                    {(documentType.key === DocumentTypeEnum.CONTRACT ||
                        documentType.key === DocumentTypeEnum.HANDOVER_PROTOCOL ||
                        documentType.key === DocumentTypeEnum.ACCEPTANCE_REPORT) &&
                        <>
                            <ClientsDropDown
                                name="company"
                                label={t("nav.clientLabel") as string}
                                setFieldValue={setFieldValue}
                                // resetForm={resetForm}
                                resetForm={() => { }}
                                value={company.key}
                                onChange={setCompany}
                            />

                            {company.data && company.data.multiDepartment ?
                                <FormDropDown
                                    name="department"
                                    headerText={t("nav.panelDepartment") as string}
                                    options={departments}
                                    onChange={setDepartment}
                                />
                                //: <OrderDetail title={company.data ? 'Oddział' : ''} value={departments[0] && departments[0].text}>  </OrderDetail>
                                : null}

                            <FormDropDownReception
                                name="receptionPlace"
                                headerText={t("nav.panelPickupPointSelect") as string}
                                options={receptionPlaces}
                                orderTypeItemId={0}
                                setReception={setReception}
                            // onChange={changePrice}
                            />
                        </>
                    }

                    {documentType.key >= 0 && documentType.key !== DocumentTypeEnum.CONTRACT &&
                        <FormDropDownInternalStore
                            name="internalStorePlace"
                            headerText={t("nav.panelInternalWarehouse") as string}
                            options={internalStoreOptions}
                            orderTypeItemId={0}
                            setInternalStore={setInternalStore}
                        />
                    }

                    {documentType.key >= 0 && documentType.key !== DocumentTypeEnum.CONTRACT &&
                        <NewFormField name="containersNumber" label={t("nav.panelQuantity") as string} type="number" min="0" />
                    }

                    <FormDatePicker name="documentDate" label={t("nav.documentDate") as string} placeholder={t("nav.selectDate") as string} values={{}} required />
                    <FileInput name="file" onChange={arrangementFileHandler} />
                    <br />

                    <NewFormBtns
                        positionAbsolute={true}
                        submitBtnText={t("nav.add") as string}
                        cancelForm={cancel}
                        disabled={isLoading}
                        disabledOnlySubmitButton={documentType.key === -1}
                    />

                    <div className={margin}>
                        {isLoading ? <ActivityIndicator /> : <ErrorMessage />}
                    </div>
                </Form>
            )}
        </Formik>
    )
};

export default StoreDocsAddForm;